import { useEffect, useState, useSyncExternalStore } from 'react';

const REDUCE = '(prefers-reduced-motion: reduce)';
const subscribe = (onChange: () => void) => {
  const mq = window.matchMedia(REDUCE);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
};
const getSnapshot = () => window.matchMedia(REDUCE).matches;
// Ön-çizimde (sunucu) tercih bilinmez, hareketli varsayılır; tarayıcı bağlanınca gerçek değer okunur. Dış depo
// olarak okunması şart: `useState` ile ilk değer tarayıcıdan gelince ön-çizilmiş HTML (sayaç 0) ile ilk istemci
// çizimi (sonuç değeri) ayrışıyor, React tüm sayfayı atıp yeniden çiziyordu.
const getServerSnapshot = () => false;

export function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/**
 * Sabit aralıkla artan sayaç; canlı önizlemeler adımlarını buna göre
 * ilerletir. Hareket azaltıldığında sayaç durur (`still` true döner),
 * önizleme sonuçlanmış hâlini göstermelidir.
 */
export function useTicker(intervalMs: number) {
  const still = usePrefersReducedMotion();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (still) return;
    const id = window.setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => window.clearInterval(id);
  }, [still, intervalMs]);

  return { tick, still };
}
